import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const COMMUNITY_APPS_LOOKUP_RESOURCE = 'communityAppsLookup';

const communityAppsService = ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_APPS_LOOKUP_RESOURCE,
      method: 'get',
      request: installationId => ({
        url: addParametersToUri(apiRoutes.communityApps(), { appInstallationId: installationId }),
      }),
    },
  ])(ComposedComponent);

export default communityAppsService;
